import { Component, ViewChildren, ContentChildren, Input, Directive, ElementRef, NgModule } from '@angular/core';
import { SessionTimerService, StgSecuredObjectDirective, OauthSessionModule } from '@stg-js-ngx-core/oauth';
import { CommonModule } from '@angular/common';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@stg-js-ngx-core/oauth';
import * as ɵngcc2 from '@angular/common';

function FooterComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 7);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "secondsToMinutes");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1("", ɵngcc0.ɵɵpipeBind1(2, 1, ctx_r0.sessionTimerService.getCount()), " ");
} }
const _c0 = ["*"];
class FooterComponent {
    constructor(sessionTimerService) {
        this.sessionTimerService = sessionTimerService;
        this.today = Date.now();
    }
    ngOnInit() {
        document.body.classList.add('kt-footer--fixed');
        if (!this.copyRightContent) {
            this.copyRightContent = "Compass Group. All Rights Reserved.";
        }
    }
    ngAfterViewInit() {
        this.allSecuredObjDirectiveList.toArray().forEach(securedObjectDirective => {
            securedObjectDirective.subscribeToRoleChange();
        });
    }
    ngAfterContentInit() {
        this.allSecuredObjDirectiveListFromTransclusion.toArray().forEach(securedObjectDirective => {
            securedObjectDirective.subscribeToRoleChange();
        });
    }
}
FooterComponent.ɵfac = function FooterComponent_Factory(t) { return new (t || FooterComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.SessionTimerService)); };
FooterComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: FooterComponent, selectors: [["stg-ngx-footer"]], contentQueries: function FooterComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, StgSecuredObjectDirective, 4, StgSecuredObjectDirective);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.allSecuredObjDirectiveListFromTransclusion = _t);
    } }, viewQuery: function FooterComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(StgSecuredObjectDirective, 5, StgSecuredObjectDirective);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.allSecuredObjDirectiveList = _t);
    } }, inputs: { copyRightContent: "copyRightContent" }, ngContentSelectors: _c0, decls: 11, vars: 6, consts: [["id", "kt_footer", 1, "kt-footer", "kt-grid__item", "kt-grid", "kt-grid--desktop", "kt-grid--ver-desktop"], [1, "kt-container", "kt-container--fluid"], [1, "kt-footer__copyright"], [1, "footer-right-align-content"], [1, "kt-footer-transclude-content"], ["class", "stg-timer", 4, "ngIf"], [1, "kt-footer__menu"], [1, "stg-timer"]], template: function FooterComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵtext(3);
        ɵngcc0.ɵɵpipe(4, "date");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "div", 3);
        ɵngcc0.ɵɵelementStart(6, "div", 4);
        ɵngcc0.ɵɵprojection(7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(8, FooterComponent_div_8_Template, 3, 3, "div", 5);
        ɵngcc0.ɵɵelementStart(9, "div", 6);
        ɵngcc0.ɵɵelement(10, "kt-scroll-top");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate2(" ", ɵngcc0.ɵɵpipeBind2(4, 3, ctx.today, "yyyy"), "\u00A0\u00A9\u00A0", ctx.copyRightContent, " ");
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngIf", ctx.sessionTimerService.timerFlag);
    } }, directives: function () { return [ɵngcc2.NgIf, ScrollTopComponent]; }, pipes: function () { return [ɵngcc2.DatePipe, ɵngcc1.SecondsToMinutesPipe]; }, styles: [".kt-footer[_ngcontent-%COMP%]{background:#1e1e2d!important;color:#d0d0d0;z-index:1}.kt-footer[_ngcontent-%COMP%]   .kt-footer__copyright[_ngcontent-%COMP%]{color:#d0d0d0;margin-left:-15px}@media (min-width: 768px){.kt-footer[_ngcontent-%COMP%]{padding:20px 10px!important}}@media (max-width: 1024px){.kt-footer[_ngcontent-%COMP%]{position:fixed;transition:all .3s ease;height:40px;bottom:0;box-shadow:0 0 28px #523f6921;display:flex;flex-direction:row;overflow:hidden;width:100%}}@media (max-width: 768px){.kt-footer[_ngcontent-%COMP%]   .kt-container[_ngcontent-%COMP%]{flex-direction:row!important;justify-content:space-between!important}}.kt-footer-transclude-content[_ngcontent-%COMP%]{display:flex;font-size:1rem;font-weight:400}.kt-footer__copyright[_ngcontent-%COMP%]{order:1;flex:0 0 auto}.footer-right-align-content[_ngcontent-%COMP%]{display:flex;order:2;justify-content:flex-end;align-items:center;flex:0 0 auto}.kt-footer[_ngcontent-%COMP%]   .kt-container[_ngcontent-%COMP%]{align-items:center;flex-wrap:wrap;align-content:center}.stg-timer[_ngcontent-%COMP%]{margin-right:-15px;padding-right:0;transition-property:padding-right;transition-duration:.25s}"] });
FooterComponent.ctorParameters = () => [
    { type: SessionTimerService }
];
FooterComponent.propDecorators = {
    allSecuredObjDirectiveList: [{ type: ViewChildren, args: [StgSecuredObjectDirective, { read: StgSecuredObjectDirective },] }],
    allSecuredObjDirectiveListFromTransclusion: [{ type: ContentChildren, args: [StgSecuredObjectDirective, { read: StgSecuredObjectDirective },] }],
    copyRightContent: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FooterComponent, [{
        type: Component,
        args: [{
                selector: 'stg-ngx-footer',
                template: "<!-- begin:: Footer -->\r\n<div class=\"kt-footer kt-grid__item kt-grid kt-grid--desktop kt-grid--ver-desktop\" id=\"kt_footer\">\r\n  <div class=\"kt-container kt-container--fluid\">\r\n    <div class=\"kt-footer__copyright\">\r\n      {{today | date:'yyyy'}}&nbsp;&copy;&nbsp;{{ copyRightContent}}\r\n    </div>\r\n    <div class=\"footer-right-align-content\">\r\n      <div class=\"kt-footer-transclude-content\">\r\n        <ng-content></ng-content>\r\n      </div>\r\n      <div class=\"stg-timer\" *ngIf=\"sessionTimerService.timerFlag\">{{ sessionTimerService.getCount() | secondsToMinutes }}\r\n      </div>\r\n      <div class=\"kt-footer__menu\">\r\n        <kt-scroll-top></kt-scroll-top>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n",
                styles: [".kt-footer{background:#1e1e2d!important;color:#d0d0d0;z-index:1}.kt-footer .kt-footer__copyright{color:#d0d0d0;margin-left:-15px}@media (min-width: 768px){.kt-footer{padding:20px 10px!important}}@media (max-width: 1024px){.kt-footer{position:fixed;transition:all .3s ease;height:40px;bottom:0;box-shadow:0 0 28px #523f6921;display:flex;flex-direction:row;overflow:hidden;width:100%}}@media (max-width: 768px){.kt-footer .kt-container{flex-direction:row!important;justify-content:space-between!important}}.kt-footer-transclude-content{display:flex;font-size:1rem;font-weight:400}.kt-footer__copyright{order:1;flex:0 0 auto}.footer-right-align-content{display:flex;order:2;justify-content:flex-end;align-items:center;flex:0 0 auto}.kt-footer .kt-container{align-items:center;flex-wrap:wrap;align-content:center}.stg-timer{margin-right:-15px;padding-right:0;transition-property:padding-right;transition-duration:.25s}\n"]
            }]
    }], function () { return [{ type: ɵngcc1.SessionTimerService }]; }, { copyRightContent: [{
            type: Input
        }], allSecuredObjDirectiveList: [{
            type: ViewChildren,
            args: [StgSecuredObjectDirective, { read: StgSecuredObjectDirective }]
        }], allSecuredObjDirectiveListFromTransclusion: [{
            type: ContentChildren,
            args: [StgSecuredObjectDirective, { read: StgSecuredObjectDirective }]
        }] }); })();

// Angular
class ScrollTopComponent {
    constructor() {
        // Public properties
        this.scrollTopOptions = {
            offset: 100,
            speed: 600
        };
    }
}
ScrollTopComponent.ɵfac = function ScrollTopComponent_Factory(t) { return new (t || ScrollTopComponent)(); };
ScrollTopComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: ScrollTopComponent, selectors: [["kt-scroll-top"]], decls: 2, vars: 1, consts: [["ktScrollTop", "", "id", "kt_scrolltop", 1, "kt-scrolltop", 3, "options"], [1, "far", "fa-arrow-alt-circle-up"]], template: function ScrollTopComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelement(1, "i", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("options", ctx.scrollTopOptions);
    } }, directives: function () { return [ScrollTopDirective]; }, styles: [".kt-scrolltop[_ngcontent-%COMP%]{background:none!important;bottom:5px!important}.kt-scrolltop[_ngcontent-%COMP%] > i[_ngcontent-%COMP%]{font-size:20px!important}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ScrollTopComponent, [{
        type: Component,
        args: [{
                selector: 'kt-scroll-top',
                template: "<!-- begin::Scrolltop -->\r\n<div ktScrollTop [options]=\"scrollTopOptions\" id=\"kt_scrolltop\" class=\"kt-scrolltop\">\r\n\t<i class=\"far fa-arrow-alt-circle-up\"></i>\r\n</div>\r\n<!-- end::Scrolltop -->\r\n",
                styles: [".kt-scrolltop{background:none!important;bottom:5px!important}.kt-scrolltop>i{font-size:20px!important}\n"]
            }]
    }], function () { return []; }, null); })();

// Angular
/**
 * Scroll to top
 */
class ScrollTopDirective {
    /**
     * Directive Conctructor
     * @param el: ElementRef
     */
    constructor(el) {
        this.el = el;
    }
    /**
     * @ Lifecycle sequences => https://angular.io/guide/lifecycle-hooks
     */
    /**
     * After view init
     */
    ngAfterViewInit() {
        this.scrollTop = new KTScrolltop(this.el.nativeElement, this.options);
    }
    /**
     * Returns ScrollTop
     */
    getScrollTop() {
        return this.scrollTop;
    }
}
ScrollTopDirective.ɵfac = function ScrollTopDirective_Factory(t) { return new (t || ScrollTopDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
ScrollTopDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: ScrollTopDirective, selectors: [["", "ktScrollTop", ""]], inputs: { options: "options" } });
ScrollTopDirective.ctorParameters = () => [
    { type: ElementRef }
];
ScrollTopDirective.propDecorators = {
    options: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ScrollTopDirective, [{
        type: Directive,
        args: [{
                selector: '[ktScrollTop]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { options: [{
            type: Input
        }] }); })();

class ScrollTopModule {
}
ScrollTopModule.ɵfac = function ScrollTopModule_Factory(t) { return new (t || ScrollTopModule)(); };
ScrollTopModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: ScrollTopModule });
ScrollTopModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ScrollTopModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    ScrollTopComponent,
                    ScrollTopDirective
                ],
                exports: [
                    ScrollTopComponent,
                    ScrollTopDirective
                ],
                imports: []
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(ScrollTopModule, { declarations: [ScrollTopComponent, ScrollTopDirective], exports: [ScrollTopComponent, ScrollTopDirective] }); })();

class FooterModule {
}
FooterModule.ɵfac = function FooterModule_Factory(t) { return new (t || FooterModule)(); };
FooterModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: FooterModule });
FooterModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule, ScrollTopModule, OauthSessionModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FooterModule, [{
        type: NgModule,
        args: [{
                declarations: [FooterComponent],
                imports: [CommonModule, ScrollTopModule, OauthSessionModule],
                exports: [FooterComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(FooterModule, { declarations: function () { return [FooterComponent]; }, imports: function () { return [CommonModule, ScrollTopModule, OauthSessionModule]; }, exports: function () { return [FooterComponent]; } }); })();

/*
 * Public API Surface of footer
 */

/**
 * Generated bundle index. Do not edit.
 */

export { FooterComponent, FooterModule, ScrollTopComponent, ScrollTopDirective, ScrollTopModule };

